import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import styles from "./BackButton.module.scss";

const propTypesBackButton = {
  linkTo: PropTypes.string.isRequired,
};
const defaultPropsBackButton = {};

const BackButton = ({ linkTo }) => {
  return (
    <Link className={`${styles.backButton} button is-light`} to={linkTo}>
      <span className={`icon ${styles.gray}`}>
        <i className="fas fa-arrow-left" />
      </span>
      <span>Back</span>
    </Link>
  );
};

BackButton.propTypes = propTypesBackButton;
BackButton.defaultProps = defaultPropsBackButton;

export default BackButton;
